/**
 * A way mark child elements as interactable.
 * Parent elements can use the shouldPropagateEvent function to determine
 * whether the event originated from an interactable child and if it should propagate.
 * (e.g. allow some interactions inside a block without automatically selecting the block)
 */

export const InteractableProps = {
  'data-interactable': 1,
};

export const shouldPropagateEvent = (event: React.MouseEvent) => {
  return !(event.target instanceof Element) || event.target.closest('[data-interactable]') === null;
};
